import React from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { LayoutCard } from "../../components/onboarding/layoutCard/LayoutCard";
import "./signup.css";
import db from "../../database";
import { getAPIClient } from "../../apiClient";

export function SignUpTemplate() {
  const navigate = useNavigate();

  async function signOut() {
    // Initiates the deleteToken() operation and continues without waiting.
    getAPIClient().deleteToken();

    db()
      .clear()
      .then(async () => {
        navigate("/");
      });
  }

  return (
    <section className="section hero height-fitcontent is-primary">
      <Link to="/" className="mt-6-desktop ml-6-desktop is-white-text" onClick={() => signOut()}>
        Back to Login
      </Link>
      <LayoutCard>
        <div className="columns">
          <div className="column is-half p-6 is-flex is-flex-direction-column">
            <Outlet />
          </div>
          <div className="column is-half is-hidden-mobile signup-image">
            <img
              src="/assets/images/Docket_Logo_Blue.png"
              alt="Docket logo"
              className="docket-signup-image"
            />
            <img src="/assets/images/LoginPic@2x.png" />
          </div>
        </div>
      </LayoutCard>
    </section>
  );
}

export default SignUpTemplate;
